import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { useEffect, useRef, useState } from 'react';
import { Form } from 'semantic-ui-react';
import { EMAIL_ERROR_MESSAGE, EMAIL_PLACEHOLDER } from './EmailField.constants';
import { isValidEmail } from '../../../utils/strings';
import './EmailField.css';
var defaultProps = {
  name: 'email',
  defaultValue: '',
  onChange: null,
  value: undefined,
  required: false
};
function EmailField(_ref) {
  var name = _ref.name,
    defaultValue = _ref.defaultValue,
    onChange = _ref.onChange,
    value = _ref.value,
    required = _ref.required;
  var _useRef = useRef(value !== undefined),
    isControlled = _useRef.current;
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    emailStateValue = _useState2[0],
    setEmailStateValue = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    message = _useState4[0],
    setMessage = _useState4[1];
  var valueDerived = isControlled ? value : emailStateValue;
  useEffect(function () {
    if (!isControlled) {
      if (!!valueDerived && !isValidEmail(valueDerived)) {
        setMessage(EMAIL_ERROR_MESSAGE);
      } else {
        setMessage('');
      }
    }
  }, [valueDerived]);
  function handleOnChange(e, target) {
    var _target$value = target.value,
      email = _target$value === void 0 ? '' : _target$value;
    var loweredCaseEmail = email.toLowerCase();
    if (!isControlled) {
      setEmailStateValue(loweredCaseEmail);
    }
    if (onChange) {
      onChange(e, _objectSpread(_objectSpread({}, target), {}, {
        value: loweredCaseEmail
      }));
    }
  }
  return /*#__PURE__*/React.createElement(Form.Field, {
    className: "email-field-container"
  }, /*#__PURE__*/React.createElement(Form.Input, {
    label: "Email Address",
    type: "email",
    value: valueDerived,
    name: name,
    placeholder: EMAIL_PLACEHOLDER,
    onChange: handleOnChange,
    required: required,
    fluid: true
  }), message && /*#__PURE__*/React.createElement("div", {
    className: "email-field-error"
  }, message, " "));
}
EmailField.defaultProps = defaultProps;
export default EmailField;